var defaultOrdinal = '%d',
    defaultDayOfMonthOrdinalParse = /\d{1,2}/;
export { defaultOrdinal, defaultDayOfMonthOrdinalParse };
export function ordinal(number) {
  return this._ordinal.replace('%d', number);
}